module.exports = __webpack_public_path__ + "img/teacherLead-1.d2c5b20d.jpg";